/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Complexe = require('../types/Complexe')
const CCb = require('./CCb')
const CCbGlob = require('../kernel/CCbGlob')
module.exports = CAppelFonctionNVar
/**
 * Objet d'un arbre binaire de calcul représentant un appel de fonction réelle utilisateur
 * à n variables.
 * @constructor
 * @extends CCb
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {Integer} nbVar : Le nombre de variables de la fonction.
 * @param {CFoncNVar} fonctionAssociee : La fonction appliquée à l'opérande.
 * @param {Array} operande : Tableau de CCb représentant les opérandes.
 * @returns {undefined}
 */
function CAppelFonctionNVar (listeProprietaire, nbVar, fonctionAssociee, operande) {
  if (arguments.length === 0) return;
  CCb.call(this, listeProprietaire);
  this.nbVar = nbVar;
  this.fonctionAssociee = fonctionAssociee;
  this.operande = operande;
}
CAppelFonctionNVar.prototype = new CCb();
CAppelFonctionNVar.prototype.constructor = CAppelFonctionNVar;
CAppelFonctionNVar.prototype.superClass = "CCb";
CAppelFonctionNVar.prototype.className = "CAppelFonctionNVar";


CAppelFonctionNVar.prototype.nature = function() {
  return CCbGlob.natAppelFonctionNVar;
};

CAppelFonctionNVar.prototype.getClone = function(listeSource, listeCible) {
  var operandeClone = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar; i++)
    operandeClone[i] = this.operande[i].getClone(listeSource, listeCible);
  // à revoir car la fonction a déjà été créée
  var ind1 = listeSource.indexOf(this.fonctionAssociee);
  return new CAppelFonctionNVar(listeCible, this.nbVar, listeCible.get(ind1, "CFoncNVar"), operandeClone);
};

CAppelFonctionNVar.prototype.resultatComplexe = function(infoRandom, zRes){
  var z1 = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar; i++) z1[i] = new Complexe();
  for (i = 0; i < this.nbVar; i++) this.operande[i].resultatComplexe(infoRandom, z1[i]);
  this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, z1, zRes);
};

CAppelFonctionNVar.prototype.resultatFonctionComplexe = function(infoRandom, valeurParametre, zRes){
  var z1 = new Array(this.nbVar);
  for (var i =0; i < this.nbVar; i++) z1[i] = new Complexe();
  for (i = 0; i < this.nbVar; i++)  this.operande[i].resultatFonctionComplexe(infoRandom, valeurParametre, z1[i]);
  this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, z1, zRes);
};

CAppelFonctionNVar.prototype.existe = function(infoRandom) {
  var res = this.fonctionAssociee.existe;
  if (!res) return false;
  for (var i = 0; i < this.nbVar; i++) res = res || this.operande[i].existe(infoRandom);
  return res;
};

CAppelFonctionNVar.prototype.resultat = function(infoRandom){
  var d = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar; i++) d[i] = this.operande[i].resultat(infoRandom);
  return this.fonctionAssociee.rendValeurFonction(infoRandom, d);
};

CAppelFonctionNVar.prototype.resultatFonction = function(infoRandom, valeurParametre){
  var d = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar; i++) d[i] = this.operande[i].resultatFonction(infoRandom, valeurParametre);
  return this.fonctionAssociee.rendValeurFonction(infoRandom, d);
};

CAppelFonctionNVar.prototype.initialisePourDependance = function() {
  CCb.prototype.initialisePourDependance.call(this);
  for (var i = 0; i < this.nbVar; i++) this.operande[i].initialisePourDependance();
};

CAppelFonctionNVar.prototype.depDe = function(p) {
  var res = CCb.prototype.depDe.call(this,p);
  for (var i = 0; i < this.nbVar; i++) res = res || this.operande[i].depDe(p);
  return this.memDep(this.fonctionAssociee.depDe(p) || res);
};

CAppelFonctionNVar.prototype.dependDePourBoucle = function(p) {
  var res = false;
  for (var i = 0; i < this.nbVar; i++) res = res || this.operande[i].dependDePourBoucle(p);
  return this.fonctionAssociee.dependDePourBoucle(p) || res;
};

CAppelFonctionNVar.prototype.dependDeVariable = function(ind) {
  var res = false;
  for (var i = 0; i < this.nbVar; i++) {
    res = res || (this.fonctionAssociee.calcul.dependDeVariable(i) && this.operande[i].dependDeVariable(ind));
  }
  return res;
};

CAppelFonctionNVar.prototype.getCopie = function() {
  var operandeCopie = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar; i++) operandeCopie[i] = this.operande[i].getCopie();
  return new CAppelFonctionNVar(this.listeProprietaire, this.nbVar, this.fonctionAssociee, operandeCopie);
};

CAppelFonctionNVar.prototype.chaineCalcul = function(varFor) {
  var ch = this.fonctionAssociee.getNom() + "(";
  for (var i = 0; i < this.nbVar - 1; i++) ch = ch + this.operande[i].chaineCalculSansPar(varFor)  + ",";
  return ch + this.operande[this.nbVar - 1].chaineCalculSansPar(varFor) + ")";
};

CAppelFonctionNVar.prototype.chaineLatex = function(varFor) {
  var ch = this.fonctionAssociee.getNom() + "(";
  for (var i = 0; i < this.nbVar - 1; i++) ch = ch + this.operande[i].chaineLatexSansPar(varFor)  + ",";
  return ch + this.operande[this.nbVar - 1].chaineLatexSansPar(varFor) + ")";
};

CAppelFonctionNVar.prototype.read = function(inps, list){
  CCb.prototype.read.call(this, inps, list);
  this.nbVar = inps.readInt();
  var ind1 = inps.readInt();
  this. fonctionAssociee = list.get(ind1,"CFoncNVar");
  this.operande = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar; i++) this.operande[i] = inps.readObject(list);
};

CAppelFonctionNVar.prototype.write = function(oups, list){
  CCb.prototype.write.call(this, oups, list);
  oups.writeInt(this.nbVar);
  var ind1 = list.indexOf(this.fonctionAssociee);
  oups.writeInt(ind1);
  for (var i = 0; i < this.nbVar; i++) oups.writeObject(this.operande[i]);
};

CAppelFonctionNVar.prototype.estConstant = function() {
  var res = this.fonctionAssociee.estConstant();
  for (var i = 0; i < this.nbVar; i++) res = res && this.operande[i].estConstant();
  return res;
};

CAppelFonctionNVar.prototype.deriveePossible = function(indiceVariable) {
  var b = true;
  for (var i = 0; (i < this.operande.length) && b; i++)
    if (this.operande[i].dependDeVariable(indiceVariable))
      b = this.fonctionAssociee.deriveePossible(i) && this.operande[i].deriveePossible(indiceVariable);
  return b;
};

CAppelFonctionNVar.prototype.calculAvecValeursRemplacees = function() {
  var nbvar = this.fonctionAssociee.nombreVariables();
  var tabcal = new Array(this.fonctionAssociee.nombreVariables());
  for (var i = 0; i < nbvar; i++) {
    tabcal[i] = this.operande[i].calculAvecValeursRemplacees();
  }
  return new CAppelFonctionNVar(this.listeProprietaire, nbvar, this.fonctionAssociee, tabcal);
};

CAppelFonctionNVar.prototype.membreGauche = function() {
  return this.fonctionAssociee.membreGauche();
};

CAppelFonctionNVar.prototype.membreDroit = function() {
  return this.fonctionAssociee.membreDroit();
};
